const env = {
    environment:
        process.env.APP_ENV === 'stable' ? 'development' : 'production',
    oneserviceApiUrl: new URL(process.env.ONESERVICE_API_URL || '').href,
};
type Environment = { [P in keyof typeof env]: string };

export default env as Environment;
